import { Theme } from '@material-ui/core/styles';

export const getMuiChip = (theme: Theme): Record<string, unknown> => ({
  MuiChip: {
    root: {
      padding: theme.spacing(0, 1),

      '&:hover': {
        borderColor: theme.palette.primary.main,
      },
    },

    label: {
      alignItems: 'center',
      display: 'flex',
      padding: 0,
    },
  },
});
